<script lang="ts">
    import {
        VpAddIcon,
        VpCalendarIcon,
        VpEditIcon,
        VpMapPinIcon,
        VpRefreshIcon,
        VpRunIcon,
        VpUserIcon,
    } from '@decathlon-experience/icons/svelte';

    import { trans } from '$assets/shop-translator.js';
    import cn from '$common/utils/cn';
    import viewport from '$saga/actions/useViewport';
    import Button from '$saga/components/Button.svelte';
    import { filtersContext } from '$saga/views/Search/store';
    import { FilterType } from '$saga/views/Search/types';
    import { redirectToGenericSearch } from '$saga/views/Search/utils';

    export let trigger, handleSelectedFilter;

    let isSticky = false;
    let filtersBarContainer: HTMLDivElement | null = null;
</script>

<div
    use:viewport
    on:enterViewport={() => {
        if (!$filtersContext.isHomePage) isSticky = false;
    }}
    on:exitViewport={() => {
        if (!$filtersContext.isHomePage) isSticky = true;
    }}
></div>
{#if isSticky}
    <div
        class="h-[42px] desktop:hidden"
        style="height: {filtersBarContainer?.clientHeight ?? '88'}px"
    ></div>
{/if}

<div
    class={cn(
        $filtersContext.isHomePage
            ? ''
            : 'relative m-auto hidden h-[42px] desktop:block',
        isSticky && !$filtersContext.isHomePage && '!max-w-full',
    )}
>
    <div
        bind:this={filtersBarContainer}
        class={cn(
            $filtersContext.isHomePage
                ? 'absolute left-1/2 top-1/2 z-30 hidden w-full max-w-layout-max -translate-x-1/2 -translate-y-1/2 px-5xl desktop:block'
                : 'absolute top-[-42px] z-30 w-full transition-all',
            isSticky &&
                !$filtersContext.isHomePage &&
                'fixed left-0 top-0 z-20 w-full !px-0',
        )}
    >
        <div
            class={cn(
                'border border-solid border-bord-quiet bg-white',
                isSticky ? 'px-5xl py-m' : 'px-s py-m',
            )}
        >
            <div class="flex gap-s">
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.SPORT);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.theme.length > 0}
                        <span
                            class="flex items-center gap-xs text-sm text-content-brand"
                        >
                            <VpRunIcon class="size-m" />
                            {trans('search.bar.sport')} ({$filtersContext
                                .formLabels.theme.length})
                        </span>
                        <span class=""><VpEditIcon size={16} /></span>
                    {:else}
                        <span class="flex items-center gap-xs text-sm">
                            <VpRunIcon class="size-m" />
                            {trans('search.bar.sport')}
                        </span>
                        <span class=""><VpAddIcon size={16} /></span>
                    {/if}
                </button>
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.DESTINATION);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.destination.length > 0}
                        <span
                            class="flex items-center gap-xs text-sm text-content-brand"
                        >
                            <VpMapPinIcon class="size-m" />
                            {trans('search.bar.destination')} ({$filtersContext
                                .formLabels.destination.length})
                        </span>
                        <span class=""><VpEditIcon size={16} /></span>
                    {:else}
                        <span class="flex items-center gap-xs text-sm">
                            <VpMapPinIcon class="size-m" />
                            {trans('search.bar.destination')}
                        </span>
                        <span class=""><VpAddIcon size={16} /></span>
                    {/if}
                </button>
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.STARTDATE);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.startDate != null || $filtersContext.formLabels.months.length > 0}
                        <span
                            class="flex items-center gap-xs whitespace-nowrap text-sm text-content-brand"
                            ><VpCalendarIcon class="size-m" />
                            {trans('search.bar.departure_date')} (1)
                        </span>
                        <span class=""><VpEditIcon size={16} /></span>
                    {:else}
                        <span
                            class="flex items-center gap-xs whitespace-nowrap text-sm"
                        >
                            <VpCalendarIcon class="size-m" />
                            {trans('search.bar.departure_date')}
                        </span>
                        <span class=""><VpAddIcon size={16} /></span>
                    {/if}
                </button>
                <button
                    class="flex w-full items-center justify-between bg-container-quiet p-s hover:bg-container-commercial-neutral"
                    on:click|preventDefault|stopPropagation={() => {
                        handleSelectedFilter(FilterType.PAX);
                    }}
                    {...$trigger}
                    use:trigger
                >
                    {#if $filtersContext.formLabels.nbPax !== '' && $filtersContext.formLabels.nbPax !== '0'}
                        <span
                            class="flex items-center gap-xs text-sm text-content-brand"
                        >
                            <VpUserIcon class="size-m" />
                            {trans('search.bar.travelers')} ({$filtersContext
                                .formLabels.nbPax})
                        </span>
                        <span class=""><VpEditIcon size={16} /></span>
                    {:else}
                        <span class="flex items-center gap-xs text-sm">
                            <VpUserIcon class="size-m" />
                            {trans('search.bar.travelers')}
                        </span>
                        <span class=""><VpAddIcon size={16} /></span>
                    {/if}
                </button>
                <Button
                    type="submit"
                    form="travel-search-engine-form"
                    data-turbo={$filtersContext.isHomePage ? false : true}
                    on:click={() => {
                        if ($filtersContext.isLandingPage) {
                            redirectToGenericSearch($filtersContext.formValues);
                        }
                    }}
                    class="w-full max-w-[14vw]"
                >
                    {#if $filtersContext.isSubmitting}
                        <VpRefreshIcon class="size-xl animate-spin " />
                    {:else}
                        {trans('search.bar.search')}
                    {/if}
                </Button>
            </div>
        </div>
    </div>
</div>
